import {Link, useLocation} from 'react-router-dom'
import {ReactElement} from "react"
import Icon from "./Icon";
import iconArrow from "../icons/IconArrow";

export function BackButton(props: {
    default_url: string,
    element?: ReactElement
}) {
    const {state} = useLocation();
    let url = props.default_url;
    let element = props.element;

    if(state && state.from_url !== null) {
        url = state.from_url;
    }

    if(!element) {
        element = <>
            <Icon component={iconArrow}/>
            <span className="text">Tilbage</span>
        </>
    }

    return <Link to={url} className='back-button-react'>{element}</Link>
}
